// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tJi7m","title":"styles_title__wa0S0","startBtn":"styles_startBtn__yYX+f"};